import styled from "styled-components";
import {GameJackpotBarToggleSliderDefaultBox} from "./game-jackpot-bar-toggle-slider.default.box";
import {baseColors} from "../../../../../../themes/definitions/casino777/base-colors";

export const GameJackpotBarToggleSliderCasino777Box = styled(GameJackpotBarToggleSliderDefaultBox)<{checked: boolean}>`
  background-color: ${props => (props.checked ? '#BC355480' : '#A4867C66')};


  &:before {
    background-color: ${props => (props.checked ? props.theme.colors.moneyColor : baseColors.base04Contrast)};
  }
`;